import { render } from "./caculator.vue?vue&type=template&id=0089bc0e"
import script from "./caculator.vue?vue&type=script&lang=js"
export * from "./caculator.vue?vue&type=script&lang=js"

import "./caculator.vue?vue&type=style&index=0&id=0089bc0e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/standard/detail-info-header/caculator.vue'],['render',render],['__file',"caculator.vue"]])

export default __exports__